<div *ngIf="isXuxThemeActivated">
  <h3 style="color: red">
    The "xuxTheme" is activated for this container, please make next changes for correct working of XUX theme:
    <ul>
      <li>connect "xux-edit.base.container.html" template</li>
      <li>connect "xux-edit.base.container.scss"</li>
    </ul>
  </h3>
</div>

<div class="panel panel-default" data-e2e-id="editor-wrapper" [attr.transaction]="saveOperationId">
  <div class="panel-heading">
    <div class="row">
      <div class="col-md-6 text-left">
        {{ title | translate}}
        <span *ngIf="showItemEditedMark$ | async" class="header-panel-edited-mark">({{ staticTextContent.edited | translate}})</span>
      </div>
      <div class="col-md-6 text-right">
        <div class="xux-dropdown btn-group pull-right">
          <button
            type="button"
            class="btn btn-default btn-primary"
            (click)="saveButtonClickHandler()"
            [disabled]="!form?.valid || !canManage"
            data-e2e-id="edit-xux-btn-save"
            *ngIf="!isDeletedDocument"
          >
            {{ staticTextContent.Save | translate }}
          </button>
          <button
            type="button"
            *ngIf="showSaveOptions && !isDeletedDocument"
            class="btn btn-default btn-primary dropdown-toggle"
            data-toggle="dropdown"
            [disabled]="!canManage"
            aria-haspopup="true"
            aria-expanded="false"
            data-e2e-id="edit-xux-btn-toggle-dropdown"
          >
            <i class="glyphicon glyphicon-menu-down"></i>
            <span class="sr-only">{{ staticTextContent.ToggleDropdown | translate }}</span>
          </button>
          <ul class="dropdown-menu" *ngIf="!isDeletedDocument">
            <li *ngIf="showSaveAndCloseButton && form?.dirty && form?.valid" [class.disabled]="!canManage">
              <a (click)="saveAndCloseBtnClick()" data-e2e-id="edit-xux-btn-save-and-close">{{ staticTextContent.SaveAndClose | translate }}</a>
            </li>
            <li *ngIf="showSaveAndNewButton && form?.dirty && form?.valid && canAdd" [class.disabled]="!canManage">
              <a (click)="saveAndNewBtnClick()" data-e2e-id="edit-xux-btn-save-and-new">{{ staticTextContent.SaveAndNew | translate }}</a>
            </li>
            <li *ngIf="document?._id && showDuplicateButton && canAdd && !documentIds?.length">
              <a (click)="duplicateBtnClick()" data-e2e-id="edit-xux-btn-duplicate">{{ staticTextContent.Duplicate | translate }}</a>
            </li>
            <li *ngIf="showCancelButton">
              <a (click)="cancelBtnClick()" data-e2e-id="edit-xux-btn-cancel">{{ staticTextContent.Cancel | translate }}</a>
            </li>
            <li *ngIf="document?._id && showDeleteButton && canRemove">
              <a (click)="deleteBtnClick()" data-e2e-id="edit-xux-btn-delete">{{ staticTextContent.Delete | translate }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="panel-body">
  <div *ngIf="error" class="alert alert-warning alert-dismissable" role="alert">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <p><strong>{{error.code | translate}}</strong> {{error.message |translate }}</p>
  </div>

  <xux-document-info-error-message
    *ngIf="isDocumentWithMessage()"
    [messageData]="infoMessageData$ | async"
  ></xux-document-info-error-message>

  <xvi-schema-form
    [form]="form"
    [groups]="groups"
    [document]="(currentDocument$ | async)"
    (onFormAction)="onFormAction($event)"
  ></xvi-schema-form>
</div>
